import React, { Component } from "react";

import "./Input.css";

class Input extends Component {
  render() {
    const { placeholder, onChangeText, children } = this.props;
    return (
      <div className="input-container">
        <input
          className="input-field"
          onChange={onChangeText}
          placeholder={placeholder}
        />
        {children}
      </div>
    );
  }
}

export default Input;



// WEBPACK FOOTER //
// ./src/components/Input/Input.js